import { render, staticRenderFns } from "./examSingUpPrive.vue?vue&type=template&id=780e385e"
import script from "./examSingUpPrive.vue?vue&type=script&lang=js"
export * from "./examSingUpPrive.vue?vue&type=script&lang=js"
import style0 from "./examSingUpPrive.vue?vue&type=style&index=0&id=780e385e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports